import { useMutation } from "react-query";
import http from "infra/http";

function useReenviarNotificacoesMensagens() {
  return useMutation(
    (id: string) => {
      return http.post(`/v1/mensagem/${id}/reenviar-notificacoes`);
    },
    { retry: false }
  );
}

export default useReenviarNotificacoesMensagens;
